
import { SubscriptionData } from "../mappers/subscriptionData.ts";
import { StripeExpressCheckoutElementOptions, StripePaymentElementOptions } from "@stripe/stripe-js";
import { ApplePayRecurringPaymentRequestIntervalUnit } from "@stripe/stripe-js/dist/stripe-js/elements/apple-pay";
import {
  getDateWithDaysOffset,
  getPeriodString,
} from "../helpers/dateHelper.ts";

const stripeExpressCheckoutTrialOptions = ({
  subscriptionData,
  trialStartDate,
  theme,
}: {
  subscriptionData: SubscriptionData,
  trialStartDate: Date,
  theme: 'black' | 'white',
}): StripeExpressCheckoutElementOptions => {
  const paymentStart = getDateWithDaysOffset( trialStartDate, subscriptionData.getDaysAmount());
  const paymentAmount = subscriptionData.getPaymentData().amount * 100;

  return {
    buttonTheme: {
      applePay: theme,
      googlePay: theme,
    },
    buttonType: {
      applePay: 'plain',
      googlePay: 'plain',
    },
    paymentMethods: {
      applePay: 'auto',
      googlePay: 'auto',
      link: 'never'
    },
    applePay: {
      recurringPaymentRequest: {
        paymentDescription: "Migiri Subscription",
        managementURL: "https://www.migiri.app/about/en/",
        regularBilling: {
          label: "Migiri Subscription",
          amount: paymentAmount,
          recurringPaymentStartDate: paymentStart,
          recurringPaymentIntervalUnit: getPeriodString(
            subscriptionData.getPaymentData().period
          )?.singular as ApplePayRecurringPaymentRequestIntervalUnit,
        },
        trialBilling: {
          label: "Trial",
          amount: 0,
          recurringPaymentStartDate: trialStartDate,
          recurringPaymentEndDate: paymentStart,
          recurringPaymentIntervalUnit: "day",
        },
      }
    }
  }
};

const stripeExpressCheckoutPaymentOptions = (theme: 'black' | 'white'): StripeExpressCheckoutElementOptions => {
  return {
    paymentMethodOrder: ['apple_pay', 'google_pay'],
    buttonTheme: {
      applePay: theme,
      googlePay: theme,
    },
    buttonType: {
      applePay: 'plain',
      googlePay: 'plain',
    },
    paymentMethods: {
      applePay: 'auto',
      googlePay: 'auto',
      link: 'never'
    },
  }
}

const stripePaymentOptions: StripePaymentElementOptions = {
  paymentMethodOrder: ['card'],
  wallets: {
    applePay: 'never',
    googlePay: 'never',
  },
}


export { stripeExpressCheckoutTrialOptions, stripeExpressCheckoutPaymentOptions, stripePaymentOptions }